import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import { SignalStep } from '../signal-step'
import './style.scss'

export function ModemAwait() {
  const dispatch = useDispatch()

  function handleNextClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_CABLE_RECONNECT))
  }

  return (
    <div className='modem-await'>
      <SignalInfo
        icon={STATICS.MODEM_RESTART}
        iconAlt='Icone de modem reiniciando'
        title='Aguarde...'
      >
        <SignalStep
          number={2}
          description='Agora aguarde de 2 a 3 minutos para que modem seja totalmente desligado.'
        />
        <p className='info'>
          <span className='bold'>Importante:</span> <span className='underline'>Todas</span> as
          luzes do equipamento precisam estar apagadas
        </p>
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleNextClick}>
          Todas as luzes apagaram
        </Button>
      </div>
    </div>
  )
}
